// Single source of truth for the TESTING_MODE enum.
// Server-side callers should prefer the named decisions on RUNTIME in
// config/env.config.ts, which validates this value through Zod.
// Client-side callers compare against these constants directly because
// env.config.ts (with dotenv) is not browser-safe.
export const TESTING_MODE = {
  MOCKED: 'mocked',
  INTEGRATION: 'integration',
} as const;

export type TestingMode = (typeof TESTING_MODE)[keyof typeof TESTING_MODE];

// Port used by the in-process Vite test server started in globalSetup.ts.
export const TEST_PORT = 63321;
